'use client';

import {
  LinkPlaceholder,
  NavTabs as NavTabsCore,
} from '@sola/ark-core/molecules/nav-tabs/nav-tabs.js';
import { NavigationProps } from '@sola/schema/lib/schema.js';

/**
 * Subpage Navigation.
 *
 * Not using ark/core/tabgroup since functionality needs are much different,
 * we want to avoid radix deps, and keeping it seperate could make the design more flexible.
 */
export const NavTabs: React.FC<NavigationProps> = ({ items }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <NavTabsCore
      links={items.map((item, index) => {
        return {
          id: index.toString(),
          title: item.title,
          path: item.link,
        } as LinkPlaceholder;
      })}
    />
  );
};
